// extracted by mini-css-extract-plugin
export default {"roomContainer":"room_type_roomContainer__9sZJq","ratesList":"room_type_ratesList__QvERr"};